import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, SectionHead, FeatureCard, TeamChip, CtaBand, Reveal } from "../components/ui.js";
import { SceneArt, Blob } from "../components/illustrations.js";

/* ============================================================
   LEVELUP ONE — About
   ============================================================ */

export default class About extends Component {
  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
  }

  render() {
    const values = [
      { icon: "🎯", title: "ลูกค้าเป็นศูนย์กลาง", desc: "เราเริ่มจากปัญหาจริงของลูกค้า ไม่ใช่เทคโนโลยีที่อยากขาย" },
      { icon: "🤝", title: "โปร่งใส", desc: "ขอบเขตงานและราคาชัดเจนตั้งแต่ต้น ไม่มีค่าใช้จ่ายแอบแฝง" },
      { icon: "🚀", title: "ส่งมอบไว", desc: "เน้นเห็นผลจริงในเวลาอันสั้น แล้วต่อยอดทีละก้าว" },
      { icon: "📚", title: "เรียนรู้ไม่หยุด", desc: "ติดตามเทคโนโลยี AI ใหม่ ๆ เพื่อยกระดับงานลูกค้า" },
    ];

    const founders = [
      { face: "👨‍💻", name: "ทีมวิศวกรรม", role: "Software & AI Engineering" },
      { face: "🎨", name: "ทีมออกแบบ", role: "Product & UX Design" },
      { face: "📞", name: "ทีมที่ปรึกษา", role: "Business Consulting" },
      { face: "🛠️", name: "ทีมซัพพอร์ต", role: "Customer Success" },
    ];

    return (
      <div className="nx">
        <Navbar />
        <PageHero
          crumb="เกี่ยวกับเรา"
          eyebrow="เกี่ยวกับเรา"
          title="เราสร้างพนักงาน AI ให้ธุรกิจไทย"
          subtitle="LevelUp One ก่อตั้งขึ้นเพื่อช่วยให้ SME ทำงานได้เร็วขึ้นด้วย AI ที่ทำงานบนระบบเดิม ไม่ต้องเริ่มใหม่จากศูนย์"
        />

        {/* Story */}
        <section className="nx-section">
          <div className="container">
            <div className="row g-5 align-items-center">
              <div className="col-12 col-lg-6">
                <Reveal>
                  <SectionHead eyebrow="เรื่องราวของเรา" title="เริ่มจากปัญหาเล็ก ๆ ของร้านค้าไทย" />
                  <p className="nx-subtitle mb-3">
                    เราเห็นว่าธุรกิจขนาดเล็กต้องเสียเวลามหาศาลกับงานซ้ำ ๆ ทั้งคีย์ข้อมูล ตอบลูกค้า และทำรายงาน
                    ทั้งที่มีเครื่องมือดี ๆ อยู่แล้ว เพียงแต่ยังไม่ถูกเชื่อมเข้าหากัน
                  </p>
                  <p className="nx-subtitle">
                    LevelUp One จึงสร้าง “พนักงาน AI” ที่เข้าไปทำงานบนระบบเดิม ช่วยให้เจ้าของธุรกิจได้เวลากลับคืน
                    ไปโฟกัสกับการเติบโตจริง ๆ
                  </p>
                </Reveal>
              </div>
              <div className="col-12 col-lg-6 position-relative">
                <Reveal delay={120}>
                  <Blob className="nx-blob" style={{ top: -60, right: -40, opacity: 0.22 }} />
                  <SceneArt kind="team" className="nx-scene mb-4" style={{ borderRadius: 24 }} />
                  <div className="nx-band">
                    <div className="row g-4 text-center position-relative">
                      <div className="col-6"><div className="nx-band__num">120<span>+</span></div><div className="nx-band__label">โปรเจกต์ส่งมอบแล้ว</div></div>
                      <div className="col-6"><div className="nx-band__num">8<span> ปี</span></div><div className="nx-band__label">ประสบการณ์ทีมงาน</div></div>
                      <div className="col-6"><div className="nx-band__num">50<span>+</span></div><div className="nx-band__label">ลูกค้าองค์กร</div></div>
                      <div className="col-6"><div className="nx-band__num">4.9<span>★</span></div><div className="nx-band__label">คะแนนความพึงพอใจ</div></div>
                    </div>
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </section>

        {/* Vision */}
        <section className="nx-section nx-bg-soft">
          <div className="container">
            <Reveal>
              <div className="text-center" style={{ maxWidth: 760, margin: "0 auto" }}>
                <span className="nx-eyebrow">วิสัยทัศน์</span>
                <h2 className="nx-heading mt-3">
                  ทำให้ AI เป็นเรื่องที่ <span className="nx-gradient-text">ทุกธุรกิจเข้าถึงได้</span>
                </h2>
                <p className="nx-subtitle" style={{ margin: "0 auto" }}>
                  เราเชื่อว่าเทคโนโลยี AI ไม่ควรเป็นของเฉพาะองค์กรใหญ่ ธุรกิจทุกขนาดควรมีทีมงาน AI
                  ที่ช่วยทำงานได้ตลอด 24 ชั่วโมง ในราคาที่จับต้องได้
                </p>
              </div>
            </Reveal>
          </div>
        </section>

        {/* Values */}
        <section className="nx-section">
          <div className="container">
            <Reveal><SectionHead center eyebrow="ค่านิยม" title="สิ่งที่เรายึดถือ" /></Reveal>
            <div className="row g-4 mt-2">
              {values.map((v, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={v.title}>
                  <Reveal delay={i * 60}><FeatureCard {...v} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal><SectionHead center eyebrow="ทีมงาน" title="คนเบื้องหลัง LevelUp One" subtitle="ทีมสหสาขาที่พร้อมดูแลตั้งแต่ออกแบบจนส่งมอบ" /></Reveal>
            <div className="row justify-content-center g-4 mt-2">
              {founders.map((m, i) => (
                <div className="col-6 col-lg-3" key={m.name}>
                  <Reveal delay={i * 60}><TeamChip {...m} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        <CtaBand />
        <Footer />
      </div>
    );
  }
}
